module.exports = __webpack_public_path__ + "img/guangxi.e802fba0.jpg";